import styled from "styled-components"
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from "recharts"
import CoinIcon from "images/character/gold_coin-66x68.png"
import ShineEffect from "images/effect/shine_effect-16x22.png"
import constants from "utils/constants"

export default function ProgressBar({ visible, reqCnt, maxCnt, successCnt, message, ...rest }) {
	const midLocation = ((successCnt / maxCnt) * 100).toFixed(2)
	const coinLocation = ((reqCnt / maxCnt) * 100).toFixed(2)
	return visible === true ? (
		<BarWrapper {...rest}>
			<BarHeader>
				정답 횟수 {successCnt}/{maxCnt}
			</BarHeader>
			<BarBody>
				<BarChartPadding>
					<BarChartWrapper>
						<StartDot />
						{successCnt > 0 && successCnt < maxCnt && <MidDot leftPos={midLocation} />}
						{reqCnt && (
							<CoinPosWrapper leftPos={coinLocation}>
								<CoinImgWrapper>
									<ShineEffectWrapper>
										<PointImg src={ShineEffect} />
									</ShineEffectWrapper>
									<PointImg src={CoinIcon} />
									<TrianglePointer />
								</CoinImgWrapper>
							</CoinPosWrapper>
						)}
						{reqCnt !== maxCnt && (
							<BellImgWrapper>
								<PointImg
									src={`${constants.imagePath}/common/icon/bell_icon-52x56.png`}
								/>
							</BellImgWrapper>
						)}
						<ResponsiveContainer width="100%" height={6}>
							<BarChart
								height={6}
								tick={false}
								layout="vertical"
								data={[{ value: successCnt }]}
								margin={{ top: 12, right: 0, bottom: 0, left: 0 }}
							>
								<YAxis
									width={0}
									type="category"
									scale="band"
									tick={false}
									tickLine={false}
									axisLine={false}
								/>
								<XAxis
									width={0}
									type="number"
									tick={false}
									tickLine={false}
									axisLine={false}
									domain={[0, maxCnt]}
								/>
								<Bar
									dataKey="value"
									fill="#4E4E4E"
									barSize={6}
									radius={16}
									background={{ fill: "#E3E3E3" }}
								/>
							</BarChart>
						</ResponsiveContainer>
						<EndDot isMax={successCnt === maxCnt} />
					</BarChartWrapper>
				</BarChartPadding>
			</BarBody>
			{message && <BarFooter>{message}</BarFooter>}
		</BarWrapper>
	) : null
}
const TrianglePointer = styled.div`
	transform: rotate(180deg);
	width: 0;
	height: 0;
	border-radius: 2px;
	border-style: solid;
	border-width: 0 3.5px 5px 3.5px;
	border-color: transparent transparent #4e4e4e transparent;

	position: absolute;
	left: 0;
	right: 0;
	bottom: -9px;
	margin-left: auto;
	margin-right: auto;
`
const BarWrapper = styled.div`
	background: #fff9e5;
	border-radius: calc(100vw * (14 / 375));
	padding: calc(100vw * (13 / 375)) calc(100vw * (25 / 375)) calc(100vw * (7.2 / 375))
		calc(100vw * (17 / 375));
`
const BarHeader = styled.div`
	font-style: normal;
	font-weight: 500;
	font-size: calc(100vw * (14 / 375));
	color: #7f7f7f;
`
const BarBody = styled.div``
const BarFooter = styled.div`
	text-align: right;
	font-weight: 500;
	font-size: calc(100vw * (12 / 375));
	line-height: 158.5%;
	color: #2f80ed;
`

const BarDot = styled.div`
	width: 13px;
	height: 13px;
	border-radius: 100%;
	background: white;
	margin: auto;
	z-index: 1;
	position: absolute;
	top: 0;
	bottom: 0;
`
const StartDot = styled(BarDot)`
	border: 2px solid #4e4e4e;
`
const MidDot = styled(BarDot)`
	background: #4e4e4e;
	left: ${({ leftPos }) => `calc(${leftPos}% - 6.5px)`};
`
const EndDot = styled(BarDot)`
	border: 2px solid #e3e3e3;
	right: calc(100vw * (-6.5 / 375));
	${({ isMax }) => isMax === true && "border: 2px solid #4e4e4e;"}
`
const BarChartPadding = styled.div`
	position: relative;
	padding: 25px 0px 4px;
`
const BarChartWrapper = styled.div`
	position: relative;
	height: 13px;
	box-sizing: content-box;
	flex: 1 1 auto;
	display: flex;
	align-items: center;
`
const CoinPosWrapper = styled.div`
	position: absolute;
	left: ${({ leftPos }) => `calc(${leftPos}% - 15px)`};
	bottom: 22px; // barHeight (13) + spaceBetweenBellAndDot(9)
`
const CoinImgWrapper = styled.div`
	position: relative;
	width: calc(100vw * (30 / 375));
	height: calc(100vw * (30 / 375));
`

const BellImgWrapper = styled.div`
	position: absolute;
	right: calc(100vw * (-7 / 375));
	bottom: 22px; // barHeight (13) + spaceBetweenBellAndDot(9)
	width: calc(100vw * (26 / 375));
	height: calc(100vw * (28 / 375));
	transform: rotate(20deg);
`
const PointImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`
const ShineEffectWrapper = styled.div`
	position: absolute;
	width: calc(100vw * (8 / 375));
	height: calc(100vw * (11 / 375));
	top: 0;
	right: calc(100vw * (-8 / 375));
`
